import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="aft-occ"
export default class extends Controller {
  connect() {
    let radio = this.element.querySelector('input[type=radio]');
    let field;
    let endAfter = this.element.querySelector('.item-group__end-occurences');
    let endOn = this.element.querySelector('.item-group__end-date');

    if(endAfter){
      field = this.element.querySelector('input[type=number]')
    } else 
    if(endOn){
      field = this.element.querySelector('input[type=text]')
    }

    field.addEventListener('change', () => {
      radio.checked = true;
    })
  }
}
